module.exports = __webpack_public_path__ + "static/media/404.185f4c1c.jpg";